export var applyStyles = function applyStyles(element, styles) {
  Object.keys(styles).forEach(function (key) {
    element.style[key] = styles[key];
  });
};